import {get, post} from "./request";

export const ticketApi = {};
ticketApi.add = async ({body}) => {
  try {
    const {data} = await post(`/ticket/add`, body);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

ticketApi.addMessage = async ({body}) => {
  try {
    const {data} = await post(`/ticketMessage/add`, body);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

ticketApi.getAll = async ({body}) => {
  try {
    const {data} = await post(`/ticket/all`, body);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

ticketApi.getOne = async ({id}) => {
  try {
    const {data} = await get(`/ticket/one/${id}`);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};
